module.exports = __webpack_public_path__ + "img/Icon_home _going.7dbf094e.svg";